<div class="form-group">
  <div class="row fields-group">
    <div class="col-auto">
      <label class="input-label">{{ 'dets.predicate' | translate }}</label>
      <select class="form-control" [(ngModel)]="operator" (ngModelChange)="operatorValueChanged()">
        <option *ngFor="let o of operators | filterOperators:multiple" [ngValue]="o">{{ o | translate }}</option>
      </select>
    </div>
    <div class="col" *ngIf="!isOperatorIsValid()">
      <div class="custom-control custom-radio custom-control-inline" *ngIf="isStatusField()">
        <!--label class="input-label">
          <input name="textValue" type="radio" [(ngModel)]="textValue" [value]="'filepending'"
            [checked]="textValue=='filepending'" (ngModelChange)="textValueChanged($event)" />
          {{ 'File pending' }}
        </label-->
        <label class="input-label">
          <input name="textValue" type="radio" [(ngModel)]="textValue" [value]="'filevalidated'"
            [checked]="textValue=='filevalidated'" (ngModelChange)="textValueChanged($event)" />
          {{ 'File validated' }}
        </label>
        <label class="input-label">
          <input name="textValue" type="radio" [(ngModel)]="textValue" [value]="'filedecline'"
            [checked]="textValue=='filedecline'" (ngModelChange)="textValueChanged($event)" />
          {{ 'File declined' }}
        </label>
        <label class="input-label">
          <input name="textValue" type="radio" [(ngModel)]="textValue" [value]="'filereject'"
            [checked]="textValue=='filereject'" (ngModelChange)="textValueChanged($event)" />
          {{ 'File rejected' }}
        </label>
      </div>
      <label class="input-label" *ngIf="!isStatusField()">{{ 'dets.predicate_value' |
        translate }}</label>
      <input class="form-control" *ngIf="!isStatusField()" type="text" name="textValue" [(ngModel)]="textValue"
        (ngModelChange)="textValueChanged($event)">
      <br>
      <label class="input-label mt-2">{{ 'dets.comparison_field_label' | translate }}</label>
      <search-select *ngIf="fields.length > 0" (change)="onTargetFormFieldKeyChange($event)" [items]="fields"
        [selected]="sourceFormFieldKey" [placeholder]="'Choose here' | translate"></search-select>
    </div>
  </div>
</div>